import React from 'react';
import { usePurchaseControllerContext } from 'contexts/PurchaseControllerContext/PurchaseControllerContext';
import { withInteractionSource } from 'contexts/InteractionSourceContext';
import { InteractionSource } from 'utils/analytics/AnalyticsV2Service.generated';
import { ModalProps } from 'modals/Modal.types';
import { useMilestonesController } from 'controllers/business/Milestones/Milestones.controller';
import { ModalCloseHandler } from '../Modal.types';
import UpsellActions from './components/UpsellActions/UpsellActions';
import SplitModal from './components/SplitModal/SplitModal';
import DescriptiveFreeUpsell from './components/DescriptiveFreeUpsell/DescriptiveFreeUpsell';

const useFreeUserFreeDownloadUpsellModal = ({
    handleClose,
    cancelPurchase,
    perform,
}: {
    handleClose: ModalCloseHandler;
    cancelPurchase: () => void;
    perform: (flag: string, shouldUpdateSession?: any) => void;
}) => {
    const handleCloseWithAnalytics = (): void => {
        handleClose();
        cancelPurchase();
        perform('FreeDownloadFreeUserUpsellViewed');
    };

    return { handleCloseWithAnalytics };
};

const FreeUserFreeDownloadUpsellModal: React.FC<ModalProps> = ({
    isOpen,
    handleClose,
}) => {
    const { perform } = useMilestonesController();
    const { cancelPurchase } = usePurchaseControllerContext();

    const { handleCloseWithAnalytics } = useFreeUserFreeDownloadUpsellModal({
        handleClose,
        perform,
        cancelPurchase,
    });

    return (
        <SplitModal isOpen={isOpen} onClose={handleCloseWithAnalytics}>
            <DescriptiveFreeUpsell />
            <UpsellActions />
        </SplitModal>
    );
};

export default withInteractionSource(
    FreeUserFreeDownloadUpsellModal,
    InteractionSource.UpsellModalFreeUserFreeDownload,
);
